var _metadata, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCodeBracket = function SvgCodeBracket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26pt",
    height: "26pt",
    viewBox: "0 0 258.000000 257.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,257.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331 2380 c-46 -11 -100 -67 -111 -116 -12 -51 -12 -1857 0 -1908 11 -51 65 -105 116 -116 51 -12 1857 -12 1908 0 55 12 106 66 117 121 11 57 11 1841 0 1898 -11 55 -62 109 -117 121 -48 12 -1865 11 -1913 0z m1917 -112 c17 -17 17 -1899 0 -1916 -17 -17 -1899 -17 -1916 0 -17 17 -17 1899 0 1916 17 17 1899 17 1916 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458 1853 c-8 -10 -108 -252 -222 -537 -177 -443 -206 -523 -197 -543 13 -28 61 -31 83 -5 8 9 108 250 222 536 198 497 206 519 191 542 -18 28 -55 31 -77 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 1464 c-201 -114 -220 -128 -220 -155 0 -25 38 -51 237 -164 170 -96 173 -97 198 -81 29 19 33 56 8 78 -10 9 -75 48 -145 88 -71 40 -128 76 -128 80 0 4 57 40 128 80 148 84 162 95 162 126 0 19 -32 54 -50 54 -3 0 -88 -48 -190 -106z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622 1555 c-26 -19 -29 -56 -4 -77 9 -8 74 -48 145 -88 70 -40 127 -76 127 -80 0 -4 -57 -40 -127 -80 -71 -40 -136 -80 -145 -88 -26 -22 -22 -59 7 -78 25 -16 28 -15 198 81 201 114 237 139 237 165 0 10 -15 30 -32 43 -33 24 -340 201 -368 212 -8 3 -25 -2 -38 -10z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCodeBracket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/codeBracket.f8a7c66f.svg";
export { ForwardRef as ReactComponent };